import { APIDocumentation } from './components/APIDocumentation';
import { TokenList } from './components/TokenList';
import { CreateToken } from './components/CreateToken';
import { FeedbackSupport } from './components/FeedbackSupport';
import { EAPNotice } from './components/EAPNotice';
/**
 *
 * Component mainly responsible for the layout of the page.
 *
 */
export function TokenManagement() {
  return (
    <>
      <TokenList />
      <CreateToken />
      <hr />
      <APIDocumentation />
      <FeedbackSupport />
      <hr />
      <EAPNotice />
    </>
  );
}
